module.exports = __webpack_public_path__ + "img/banner.670304da.jpg";